import { AxiosError } from 'axios';

export const getErrorFromAxiosError = (error: AxiosError): string =>
  `${error.message}: ${(error.response?.data as { message?: string }).message}`;
